    
<template>
    <a-spin :spinning="tloading">
        <div class="dashBox">
            <div class="dashTitle">异常类型饼图</div>
            <a-empty v-if="listerrorsys.length == 0" style="margin-top:80px;"  />

            <div id="errorpie"  style="width: 100%;"></div>
        </div>
    </a-spin>
</template>

<script>
export default {
    data() {
        return {
            chartSys:null,
            tloading:false,
            listerrorsys:[]
        }
    },
    props:{
      
    },
    methods: {
        loadData(selectedEnv,selectedWebSys,sTimeRange){
            let queryStr = "* | select count(1) as pv,js_err_name as name from log where log_type = 'js-error' and project_name='" + selectedWebSys + "' group by js_err_name";
            let that = this;
            that.tloading = true;
            let sTime = sTimeRange.split('~')[0];
            let eTime = sTimeRange.split('~')[1];
            let starttime = (new Date(sTime).getTime())/1000;
            let endtime = (new Date(eTime).getTime())/1000;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.listerrorsys = result.list;
                    that.analystData();
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
                document.getElementById("errorpie").style.height = "0px";
            }
            if(this.listerrorsys.length == 0){
                return
            }
            document.getElementById("errorpie").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("errorpie"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
                // that.$router.push({
                //     path: "/monitorerror/trend",
                //     query:{
                //         sysname:params.name
                //     }
                // });
            });
            
        },
        getDatailOption(){
            let that = this;

            let resultData = [];
            let array = that.listerrorsys;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                resultData.push({
                    name:element.name,
                    value:element.pv
                })
            }
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show:false
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: '5px',
                    top:'bottom'
                },
                color:that.G.getChartColors(),
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        data: resultData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    }
}
</script>

<style scoped>
.dashBox{
        min-height: 422px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;

    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }
</style>

<style>

</style>